import React from 'react'
import { ProgressBar } from 'react-bootstrap';

export const ProgressComponent = ({progressDone}) => {
    return (
        <div className='bt-progress' >
            <ProgressBar animated now={progressDone} label={`${progressDone}%`} />
            <p className='text-center progress-text'>Please wait. Consent accept request is under process...</p>
        </div>
    )
}
